import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";

const ProluxFilter = ({ filterCalc, supply }) => {
  return (
    <View
      style={{
        border: "2px solid black",
        fontSize: "8px",
        marginTop: "10px",
        paddingHorizontal: "5px",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderBottom: "1px solid black",
        }}
      >
        <View style={{ width: "70%" }}>
          <Text>Filterteil {supply ? "Zuluft" : "Fortluft"}</Text>
        </View>
      </View>

      <View style={{ display: "flex", flexDirection: "row" }}>
        <View style={{ width: "2%" }}>
          <Text>1</Text>
        </View>
        <View
          style={{
            width: "96%",
            borderLeft: "1px solid black",
            borderRight: "1px solid black",
          }}
        >
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
            }}
          >
            <View
              style={{
                paddingLeft: "2px",
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Luftfilter Fabrikat</Text>
              <Text>{filterCalc.type}</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Filterklasse</Text>
              <Text>
                {filterCalc.classEN779} / {filterCalc.classISO16890}
              </Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Filterart</Text>
              <Text> Taschen-Filter</Text>
            </View>
            <View
              style={{
                borderRight: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
              }}
            >
              <Text>Druckverlust Neu</Text>
              <Text>{filterCalc.initPressureDrop} Pa</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
                // flex: "1",
              }}
            >
              <Text>Druckverlust Ende</Text>
              <Text>{filterCalc.recFinalPressDrop} Pa</Text>
            </View>
          </View>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              textAlign: "center",
              borderTop: "1px solid black",
            }}
          >
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
                borderRight: "1px solid black",
                // flex: "1",
              }}
            >
              <Text>Luftvolumenstrom</Text>
              <Text>{filterCalc.airFlow} m³/h</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
                borderRight: "1px solid black",
                // flex: "1",
              }}
            >
              <Text>Filterfläche</Text>
              <Text>{filterCalc.surface} m²</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "20%",
                borderRight: "1px solid black",
                // flex: "1",
              }}
            >
              <Text>Einbau</Text>
              <Text>ausziehbar</Text>
            </View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40%",

                // flex: "1",
              }}
            >
              <Text>Energieklasse Eurovent</Text>
              <Text>{filterCalc.energyClass}</Text>
            </View>
          </View>
          <View style={{ paddingLeft: "2px", borderTop: "1px solid black" }}>
            <Text>Anzahl / Typ Filterzellen</Text>
          </View>
          <View
            style={{
              borderTop: "1px solid black",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <View
              style={{
                borderRight: "1px solid black",
                paddingLeft: "2px",
                width: "20%",
                display: "flex",
                justifyContent: "space-around",
                flexDirection: "row",
              }}
            ></View>
            <View
              style={{
                paddingLeft: "2px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Text style={{ marginRight: "20px" }}></Text>
              <Text>{filterCalc.dimension}</Text>
            </View>
          </View>
          <View
            style={{
              paddingLeft: "2px",
              borderTop: "1px solid black",
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: "10px" }}>
              <b>Zubehör</b>
            </Text>
            <Text style={{}}>1 Set Reservefilter</Text>
          </View>
          <View
            style={{
              paddingLeft: "2px",
              borderTop: "1px solid black",
              height: "30px",
            }}
          >
            <Text style={{ fontWeight: "600", fontSize: "10px" }}>
              Bemerkungen:
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};
export default ProluxFilter;
